var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"o-btn",class:[
    { 'o-btn--icon-r': _vm.iconPosition === 'right' },
    { 'o-btn--icon-l': _vm.iconPosition === 'left' }
  ],attrs:{"type":_vm.type}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.icon)?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }